Hop.defineModule('changelocale', (root) => {
    const $root = $(root);
    const $select = $root.find('select');

    function onChange() {
        const value = $select.val();
        const newUrl = new Url();
        newUrl.query.lg = value;
        window.location.href = newUrl;
    }

    function init() {
        const newUrl = new Url();

        let fixUrl = false;

        if (newUrl.query['x-auth'] !== undefined) {
            delete newUrl.query['x-auth'];
            fixUrl = true;
        }

        if (fixUrl) {
            if (window.history && typeof window.history.replaceState === 'function') {
                history.replaceState(history.state, window.title, '' + newUrl);
            } else {
                window.location.href = newUrl;
            }
        }

        $select.on('change', onChange);
    }

    init();

    return function destroy() {
        $select.off('change', onChange);
    };
});
